import { providers } from '@/returns/constants'

const prestashopOrderIdHelp = {
  description:
    'Abre el pedido para editar en PrestaShop y copia el número de la URL. No es la referencia en pantalla. Pídeselo a quien administre tu tienda.',
  example: '...&id_order=1345 → tu order_id es 1345',
}

export const orderIdHelpByProvider = {
  [providers.shopify]: {
    description:
      'Abre el pedido en tu admin de Shopify y copia el número de la URL. No es el número de pedido de arriba, ni el checkout.',
    example: 'yourstore.myshopify.com/admin/orders/6234567890123 → tu order_id es 6234567890123',
  },
  [providers.bigcommerce]: {
    description: 'Usa el número de pedido de tu lista o detalle de pedido de BigCommerce.',
    example: 'Pedido #10482 → tu order_id es 10482',
  },
  [providers.woocommerce]: {
    description: 'Usa el número de pedido de tu lista de WooCommerce, tras el símbolo #.',
    example: 'Pedido #4821 → tu order_id es 4821',
  },
  [providers.magento]: {
    description:
      'Abre el pedido para editar en Magento y copia el número de la URL. No es el número de la tabla. Pídeselo a tu desarrollador si no lo encuentras.',
    example: '.../order/view/order_id/482 → tu order_id es 482',
  },
  [providers.prestashop]: prestashopOrderIdHelp,
  [providers.prestashop_with_module]: prestashopOrderIdHelp,
}
